import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path d="M16 11.5H6V10H16V11.5Z" />
    <path d="M6 16H16V14.5H6V16Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.75 1C6.7835 1 6 1.7835 6 2.75V5H2.75C1.7835 5 1 5.7835 1 6.75V19.25C1 20.2165 1.7835 21 2.75 21H19.25C20.2165 21 21 20.2165 21 19.25V6.75C21 5.7835 20.2165 5 19.25 5H16V2.75C16 1.7835 15.2165 1 14.25 1H7.75ZM14.5 5V2.75C14.5 2.61193 14.3881 2.5 14.25 2.5H7.75C7.61193 2.5 7.5 2.61193 7.5 2.75V5H14.5ZM2.5 6.75C2.5 6.61193 2.61193 6.5 2.75 6.5H19.25C19.3881 6.5 19.5 6.61193 19.5 6.75V19.25C19.5 19.3881 19.3881 19.5 19.25 19.5H2.75C2.61193 19.5 2.5 19.3881 2.5 19.25V6.75Z"
    />
  </svg>
);
